import posthog from "posthog-js";

export const MARKET_ITEM_CLICK_EVENT = "market_item_click" as const;

/** Where on /market the buyer opened a listing preview. */
export type MarketItemClickSource =
  | "grid"
  | "list"
  | "confirmed_shelf"
  | "related";

export type CaptureMarketItemClickParams = {
  listingId: string;
  category: string;
  subcategory?: string | null;
  listingPrice: number;
  source: MarketItemClickSource;
  sort: string;
  hasFilters: boolean;
};

/**
 * Buyer/marketplace: listing opened from /market (preview modal).
 * Single owner for the browse → open job metric proposed in
 * buyer-market-discovery-ux Phase 0 analytics baseline.
 */
export function captureMarketItemClick(
  params: CaptureMarketItemClickParams,
): void {
  try {
    posthog.capture(MARKET_ITEM_CLICK_EVENT, {
      listing_id: params.listingId,
      category: params.category,
      subcategory: params.subcategory || null,
      listing_price: params.listingPrice,
      source: params.source,
      sort: params.sort,
      has_filters: params.hasFilters,
    });
  } catch (error) {
    console.warn("[posthog] market_item_click capture failed:", error);
  }
}
